"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VideoEvent;
(function (VideoEvent) {
    VideoEvent["ERROR"] = "video-events/error";
    VideoEvent["STATE_CHANGED"] = "video-events/state-changed";
    VideoEvent["LIVE_STATE_CHANGED"] = "video-events/live-state-changed";
    VideoEvent["DYNAMIC_CONTENT_ENDED"] = "video-events/dynamic-content-ended";
    VideoEvent["CHUNK_LOADED"] = "video-events/chunk-loaded";
    VideoEvent["CURRENT_TIME_UPDATED"] = "video-events/current-time-updated";
    VideoEvent["DURATION_UPDATED"] = "video-events/duration-updated";
    VideoEvent["SOUND_STATE_CHANGED"] = "video-events/sound-state-changed";
    VideoEvent["VOLUME_CHANGED"] = "video-events/volume-changed";
    VideoEvent["MUTE_CHANGED"] = "video-events/mute-changed";
    VideoEvent["SEEK_IN_PROGRESS"] = "video-events/seek-in-progress";
    VideoEvent["UPLOAD_STALLED"] = "video-events/upload-stalled";
    VideoEvent["UPLOAD_SUSPEND"] = "video-events/upload-suspend";
    VideoEvent["PLAY_REQUEST"] = "video-events/play-request";
    VideoEvent["PLAY_ABORTED"] = "video-events/play-aborted";
    VideoEvent["RESET"] = "video-events/reset-playback";
})(VideoEvent || (VideoEvent = {}));
exports.default = VideoEvent;
//# sourceMappingURL=video.js.map